// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer vierkant {
  .v-validate-pristine--style, .v-formControl.v-validate-pristine .ng-invalid.v-component-container, .v-formControl.v-validate-pristine .ng-invalid.p-component,
  .v-formControl .ng-invalid.ng-dirty.v-component-container,
  .v-formControl .ng-invalid.ng-dirty.p-component {
    --dropdown-border: 1px solid var(--gc-color-danger);
    border-color: var(--gc-color-danger) !important;
    outline: solid 1px var(--gc-color-danger);
    outline-offset: -4px;
  }
  .v-required .v-component-label:after,
  .v-formControl.v-required .v-component-label:after {
    content: "*";
    margin-left: 0.25rem;
    color: var(--gc-color-danger);
  }
  .v-readonly, .v-readonly input {
    -webkit-user-select: none;
            user-select: none;
    pointer-events: none;
  }
}
@layer vierkant {
  v-stepper {
    --p-button-rounded-border-radius: var(--stepper-button-border-radius) !important;
    display: contents !important;
  }
  v-stepper p-stepper {
    width: var(--stepper-width-full);
  }
  v-stepper p-stepper .p-steplist {
    align-items: flex-start !important;
  }
  v-stepper p-stepper-separator {
    margin-top: var(--stepper-separator-margin-top);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/wrappers/lib/validation.sass","webpack://./src/app/modules/wrappers/lib/stepper/stepper.component.sass"],"names":[],"mappings":"AAAA;EACI;;;IACI,mDAAA;IACA,+CAAA;IACA,yCAAA;IACA,oBAAA;ECGN;EDDE;;IAEI,YAAA;IACA,oBAAA;IACA,6BAAA;ECGN;EDGE;IACI,yBAAA;YAAA,iBAAA;IACA,oBAAA;ECDN;AACF;AAlBA;EACI;IACI,gFAAA;IACA,4BAAA;EAoBN;EAnBM;IACI,gCAAA;EAqBV;EApBU;IACI,kCAAA;EAsBd;EArBM;IACI,+CAAA;EAuBV;AACF","sourcesContent":["@layer vierkant\n    .v-validate-pristine--style\n        --dropdown-border: 1px solid var(--gc-color-danger)\n        border-color: var(--gc-color-danger) !important\n        outline: solid 1px var(--gc-color-danger)\n        outline-offset: -4px\n\n    .v-required .v-component-label:after,\n    .v-formControl.v-required .v-component-label:after\n        content: '*'\n        margin-left: 0.25rem\n        color: var(--gc-color-danger)\n    .v-formControl.v-validate-pristine .ng-invalid, \n    .v-formControl .ng-invalid.ng-dirty\n        &.v-component-container, &.p-component\n            @extend .v-validate-pristine--style    \n\n    .v-readonly, .v-readonly input\n        user-select: none\n        pointer-events: none","@use '../validation.sass'\n@layer vierkant\n    v-stepper\n        --p-button-rounded-border-radius: var(--stepper-button-border-radius) !important\n        display: contents !important\n        p-stepper\n            width: var(--stepper-width-full)\n            .p-steplist\n                align-items: flex-start !important\n        p-stepper-separator\n            margin-top: var(--stepper-separator-margin-top)"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
